import script from "./acquaint-info-text-area.vue?vue&type=script&setup=true&lang=ts"
export * from "./acquaint-info-text-area.vue?vue&type=script&setup=true&lang=ts"

import "./acquaint-info-text-area.vue?vue&type=style&index=0&id=59082da1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59082da1"]])

export default __exports__